import React, { Component } from 'react'
import styled from 'styled-components'

import * as themeUtilities from '@/utilities/client-components/utilities/themeUtils'

import { Input } from './Input'
import { StyledInputContainer } from './StyledInput'
import withSpacing from './WithSpacing'

const StyledToggleWrap = styled.div`
  display: block;
`
const StyledTitle = styled.span`
  color: ${(props: any) => themeUtilities.getRgbaColor(props.theme, props.color || 'medium', props.isSubtle)};
  font-size: ${(props: any) =>
    themeUtilities.getFontSize(
      props.theme,
      // eslint-disable-next-line unicorn/explicit-length-check
      props.size || 'default'
    )}px;
`

const StyledToggle = styled.input`
  margin-right: 8px;
`

interface InputToggleProps {
  as?: React.ReactNode
  label?: string
  title: string
  value?: string
  valueOff?: string
  valueOn?: string
}

class InputToggle extends Component<InputToggleProps> {
  static displayName = 'InputToggle'

  static defaultProps = {
    isRequired: false,
    value: '',
    style: 'expanded'
  }

  getValue = (currentValue: any) => {
    if (currentValue) {
      return this.props.value || this.props.valueOn || currentValue
    } else {
      return this.props.valueOff || currentValue
    }
  }

  render() {
    const { title, label } = this.props
    return (
      // @ts-expect-error
      <Input
        {...this.props}
        valueOverride={this.getValue}
        render={(setState, value) =>
          // @ts-expect-error
          StyledToggleGroup({ value, title, label, setValue: (value: any) => setState({ value }) })
        }
      />
    )
  }
}

interface StyledToggleGroupProps {
  as?: string | React.ReactNode | ((...args: unknown[]) => unknown)
  error?: string
  label?: string
  setValue?(...args: unknown[]): unknown
  title?: string
  value?: string
}

const StyledToggleGroup = ({ value, setValue, title, as, error, label }: StyledToggleGroupProps) => {
  return (
    <StyledInputContainer label={label} error={error}>
      <StyledToggleComponent value={value} setValue={setValue} title={title} as={as} />
    </StyledInputContainer>
  )
}

StyledToggleGroup.defaultProps = {
  setValue: () => {}
}

interface StyledToggleComponentProps {
  as?: string | React.ReactNode | ((...args: unknown[]) => unknown)
  setValue?(...args: unknown[]): unknown
  title?: string
  value?: string
}

const StyledToggleComponent = ({ value, setValue, title, as }: StyledToggleComponentProps) => {
  return (
    <StyledToggleWrap>
      {/* @ts-expect-error */}
      <StyledToggle type="checkbox" as={as} value={value || title} onChange={() => setValue(!value)} />
      <StyledTitle>{title || value}</StyledTitle>
    </StyledToggleWrap>
  )
}

export { StyledToggleComponent, InputToggle } // For use in ChoiceSet and tests

export default withSpacing(InputToggle)
